import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import NotificationsIcon from "@mui/icons-material/Notifications";
import Tooltip from "@mui/material/Tooltip";
import { useEffect, useState } from "react";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import classes from "./NotificationIcon.module.css";
import {
  type NotificationObject,
  makeNotification,
} from "../../utils/helpers/notificationMaker";
import { buildNotificationTarget } from "../../utils/helpers/notificationNavigation";
import AuthContext from "../../store/auth-context";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { useNotificationContext } from "../../NotificationContext";
import { useMessageFeed } from "../../MessageFeedContext";
import { useHistoricalDataContext } from "../../HistoricalDataContext";


const NotificationIcon = () => {
  const navigate = useNavigate();

  const { addMessage } = useMessageFeed(); // Usamos el contexto para agregar mensajes de tipo "data"

  const { notifications, addNotification, clearNotifications } =
    useNotificationContext();
  const {
    setAlertStartDate,
    setAlertEndDate,
    setGeneralStartDate,
    setGeneralEndDate,
  } = useHistoricalDataContext();

  const [open, setOpen] = useState(false);

  const [bagdeNumber, setBagdeNumber] = useState(notifications.length);

  const [read, setRead] = useState(false);

  // Límite configurable para mostrar últimas notificaciones en la campanita
  const resolvedBellLimit = (() => {
    const raw = process.env.REACT_APP_NOTIFICATIONS_BELL_LIMIT;
    if (raw === undefined) return 50; // valor por defecto
    const n = parseInt(raw, 10);
    // Evitar casos como 0 que harían slice(-0) => slice(0) (todo)
    return Number.isFinite(n) && n > 0 ? n : 50;
  })();

  const authCtx = useContext(AuthContext);

  let email = authCtx.userEmail;

  const wssEndpoint =
    process.env.REACT_APP_WEB_SOCKET_EXTERNAL_ENDPOINT ||
    `${window.location.protocol === "https:" ? "wss" : "ws"}://${window.location.host}/ws`;
  const [wsState, setWsState] = useState<WebSocket | undefined>(undefined);

  // Single useEffect to manage WebSocket lifecycle
  useEffect(() => {
    if (!wssEndpoint) return;

    let ws: WebSocket | null = null;
    let reconnectTimeout: NodeJS.Timeout | null = null;

    const connect = () => {
      // Clean up existing connection if any
      if (ws) {
        ws.close();
      }

      ws = new WebSocket(wssEndpoint);
      setWsState(ws);

      ws.onopen = () => {
        console.log("WebSocket opened!");
        const userEmail = email || "test@test";
        if (ws && ws.readyState === WebSocket.OPEN) {
          ws.send("USER:" + userEmail);
        }
      };

      ws.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);

          if (data.type === "alert") {
            const notification = makeNotification(data);
            // Mostrar alertas del usuario logueado y alertas de sistema (monitor/anomaly o sin user)
            const isSystem = !notification?.user || notification?.user === 'monitor' || notification?.user === 'anomaly';
            if (notification && (notification.user === email || isSystem)) {
              addNotification(notification);
              setBagdeNumber(notifications.length);
              console.log("Mensaje de tipo alert agregado al context notification:", notification);
            } else {
              console.log("Alerta ignorada por usuario distinto", notification?.user, email);
            }
          } else if (data.type === "data") {
            addMessage(data); // Agrega mensaje al contexto de messageFeed
            console.log("Mensaje de tipo data agregado al context feed:", data);
          } else {
            console.log("Mensaje de control recibido:", data);
          }
        } catch (error) {
          console.error("Error procesando mensaje WebSocket:", error);
        }
      };

      ws.onerror = (error) => {
        console.error("WebSocket error:", error);
      };

      ws.onclose = () => {
        console.log(`WebSocket closed for user: ${email}. Reconnecting in 3s...`);
        setWsState(undefined);
        // Reconnect after 3 seconds
        reconnectTimeout = setTimeout(() => {
          console.log("Attempting to reconnect...");
          connect();
        }, 3000);
      };
    };

    // Initial connection
    connect();

    // Cleanup function
    return () => {
      console.log("Cleaning up WebSocket connection");
      if (reconnectTimeout) {
        clearTimeout(reconnectTimeout);
      }
      if (ws) {
        ws.close();
        ws = null;
      }
    };
  }, [wssEndpoint, email]); // Recreate connection if endpoint or email changes


  useEffect(() => {
    const mine = notifications.filter((n) => n.user === email || !n.user || n.user === 'monitor' || n.user === 'anomaly');
    setBagdeNumber(mine.length);
    setRead(false);
  }, [notifications, email]);

  const toggleDialog = () => {
    if (!open && !read) {
      setRead(true);
    }
    // Permitir abrir/cerrar aunque no haya notificaciones, para mostrar el estado vacío
    setOpen((prev) => !prev);
  };

  const commitNot = () => {
    // Limpia inmediatamente del lado del cliente
    clearNotifications();
    setBagdeNumber(0);
    setRead(true);

    // Notifica al backend de la limpieza
    const safeSend = () => {
      const s = wsState as unknown as WebSocket | undefined;
      try { s?.send("COMMIT:" + email); } catch (_) { }
    };
    safeSend();
    // Reintento si el socket aún no estaba listo
    setTimeout(safeSend, 3000);
  };

  const handleNotificationClick = (notification: NotificationObject) => {
    setOpen(false);
    const notificationTarget = buildNotificationTarget(notification);
    if (notificationTarget) {
      navigate(notificationTarget);
    }

    if (notification.recvTime) {
      console.log("Timestamp de la notificación seleccionada: " + notification.recvTime);

      // Validar el formato de recvTime

      const startDate = new Date(notification.recvTime);

      if (isNaN(startDate.getTime())) {
        console.error("Fecha de notificación inválida:", notification.recvTime);
        return;
      }

      const offsetGeneralDate = parseInt(process.env.REACT_APP_OFFSET_GENERAL_DATE ?? "7200000", 10); // radio del intervalo en ms
      const endDate = new Date(startDate.getTime() + 1000); // Añadir 1 segundo para el rango de fecha

      console.log("notification: " + JSON.stringify(notification));
      console.log("Fecha de notificación clickeada: ", startDate);

      console.log("start date: " + startDate);
      setAlertStartDate(startDate);
      console.log("end date: " + endDate)
      setAlertEndDate(endDate);
      console.log("start date get time:" + startDate.getTime());
      // Centrar la ventana temporal alrededor del momento de la alerta
      setGeneralStartDate(new Date(startDate.getTime() - offsetGeneralDate));
      setGeneralEndDate(new Date(startDate.getTime() + offsetGeneralDate));
    } else {
      console.log("La notificación no tiene una fecha definida.");
    }
  };


  return (
    <Tooltip title="Últimas notificaciones" disableHoverListener={open} disableFocusListener={open} disableTouchListener={open}>
      <IconButton
        color="inherit"
        onClick={toggleDialog}
        className={classes.icon_container}
      >
        <Badge badgeContent={read ? 0 : bagdeNumber} color="secondary">
          <NotificationsIcon />
        </Badge>
        {open ? (
          <div className={classes.dialog}>
            <div className={classes.header}>
              <div className={classes.headerTitle}>Notificaciones</div>
              <Tooltip title="Eliminar todas las notificaciones" placement="left" arrow>
                <IconButton size="small" onClick={commitNot} aria-label="Eliminar todas">
                  <DeleteOutlineIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </div>
            <div className={classes.listBody}>
              {(notifications
                .filter((n) => n.user === email || !n.user || n.user === 'monitor' || n.user === 'anomaly')
                .slice(-resolvedBellLimit)
              ).map((noti, index) => (
                <div
                  key={index}
                  className={classes.noti_container_read}
                  onClick={(event) => {
                    event.stopPropagation();
                    handleNotificationClick(noti);
                  }}
                >
                  <div className={classes.noti_row}>
                    <span className={classes.noti_icon}>
                      {noti.trend === 'up' ? (
                        <ArrowUpwardIcon fontSize="small" className={classes.icon_up} />
                      ) : (
                        <ArrowDownwardIcon fontSize="small" className={classes.icon_down} />
                      )}
                    </span>
                    <div className={classes.noti_main}>
                      <div className={classes.noti_title}>
                        <strong>{noti.contextName}</strong>
                        <span className={classes.noti_attr}>
                          {noti.attr || noti.ruleTagName}
                        </span>
                        {(() => {
                          const rt = String(noti.ruleTagName || '').toLowerCase();
                          if (rt === 'medianband') {
                            return <span className={`${classes.noti_tag} ${classes.tag_median}`}>MEDIAN</span>;
                          } else if (rt === 'rateofchange') {
                            return <span className={`${classes.noti_tag} ${classes.tag_roc}`}>ROC</span>;
                          } else if (rt === 'freshness') {
                            return <span className={`${classes.noti_tag} ${classes.tag_freshness}`}>FRESH</span>;
                          } else if (rt === 'staleness') {
                            return <span className={`${classes.noti_tag} ${classes.tag_stale}`}>STALE</span>;
                          } else if (rt === 'stuckvalue' || rt === 'freezevalue' || rt === 'stuck') {
                            return <span className={`${classes.noti_tag} ${classes.tag_stuck}`}>FREEZE</span>;
                          } else if (rt === 'communityobservation') {
                            return <span className={`${classes.noti_tag} ${classes.tag_community}`}>CIUDADANA</span>;
                          } else if (rt.endsWith('umbral') || rt.includes('threshold')) {
                            return <span className={`${classes.noti_tag} ${classes.tag_threshold}`}>UMBRAL</span>;
                          }
                          return null;
                        })()}
                      </div>
                      <div className={classes.noti_action}>
                        {(noti.action || '').replace(/[\u2B06\uFE0F\u2B07]|[⬆️⬇️]/g, '').trim()}
                      </div>
                    </div>
                  </div>
                  <div className={classes.date_container}>
                    <small>
                      {noti.recvTime
                        ? new Date(noti.recvTime).toLocaleString()
                        : "Fecha no disponible"}
                    </small>
                  </div>
                </div>
              ))}
              {notifications.length === 0 && (
                <div className={classes.empty_state}>Sin notificaciones</div>
              )}
            </div>
          </div>
        ) : (
          ""
        )}
      </IconButton>
    </Tooltip>
  );
};

export default NotificationIcon;
